import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {

  themeSignal = signal<string>((localStorage.getItem("theme")?.includes('dark') ?? false) ? 'dark' : 'light');

  constructor() { }

  setTheme(theme: string) {
    var color = localStorage.getItem("color") ?? "blue";
    this.themeSignal.set(theme);
    document.body.classList.add(theme + '-' + color);
    localStorage.setItem("theme", theme);
    localStorage.setItem("color", color);
  }

  updateTheme(newColor?: string) {
    const currentTheme = localStorage.getItem("theme") ?? "light";

    if (!newColor) {
      this.themeSignal.update(value => (currentTheme == 'dark' ? 'light' : 'dark'));
    }

    const currentColor = localStorage.getItem("color") ?? "blue";
    const color = newColor ?? currentColor;
    const theme = newColor ? currentTheme : this.themeSignal();



    document.body.classList.remove(currentTheme + '-' + currentColor);
    document.body.classList.add(theme + '-' + color);
    localStorage.setItem("theme", theme);
    localStorage.setItem("color", color);

  }
}
